import { render, staticRenderFns } from "./BottomList.vue?vue&type=template&id=9802b20e&scoped=true&"
import script from "./BottomList.vue?vue&type=script&lang=js&"
export * from "./BottomList.vue?vue&type=script&lang=js&"
import style0 from "./BottomList.vue?vue&type=style&index=0&id=9802b20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9802b20e",
  null
  
)

export default component.exports